import type {
  AssetState,
  AssetToWorkflowStateMapping,
  AssetWorkflowStepOptions,
  WorkflowStateToAssetMapping,
  WorkflowStepOptions,
} from './types';
import { WorkflowStep } from './WorkflowStep';
export interface WorkflowOptions {
  workflowName: string;
  workflowSteps: WorkflowStepOptions[];
}

export class AssetWorkflowStep extends WorkflowStep {
  public readonly workflowStateToAssetMapping?: WorkflowStateToAssetMapping;
  public readonly assetToWorkflowMapping?: AssetToWorkflowStateMapping;
  constructor(workflowKey: string, options: AssetWorkflowStepOptions, assetState: AssetState) {
    super(workflowKey, options, assetState);
    this.workflowStateToAssetMapping = options.workflowStateToAssetMapping;
    this.assetToWorkflowMapping = options.assetToWorkflowStateMapping;
  }
}
